// extracted by mini-css-extract-plugin
module.exports = {"themeRoot":"TextComponent_themeRoot__2k0qV","gwMediaSidebarTextContainer":"TextComponent_gwMediaSidebarTextContainer__eP8uX"};